/**
 * Appointment Outcome — dedicated route (/appointment-outcome/:id)
 * ────────────────────────────────────────────────────────────────
 * Full-page surface for the structured Outcome Record. Source of truth
 * for what happened at an appointment.
 */
import { useParams, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { AppointmentOutcomePanel } from "@/components/sales/AppointmentOutcomePanel";

export default function AppointmentOutcomeRoute() {
  const { appointmentResultId } = useParams<{ appointmentResultId: string }>();

  if (!appointmentResultId) {
    return (
      <div className="p-6 max-w-3xl mx-auto">
        <p className="text-sm text-muted-foreground">No appointment result specified.</p>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto space-y-4">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Link to="/" className="inline-flex items-center gap-1 hover:text-foreground">
          <ChevronLeft className="h-4 w-4" />
          Back
        </Link>
        <span>·</span>
        <span>Appointment outcome</span>
        <span className="text-foreground/40">·</span>
        <code className="text-xs bg-muted px-1.5 py-0.5 rounded">{appointmentResultId}</code>
      </div>
      <AppointmentOutcomePanel appointmentResultId={appointmentResultId} />
    </div>
  );
}
